import { circles } from "@/mocks/community";
import SectionHeading from "./SectionHeading";

export default function Circles() {
  return (
    <section id="circles" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="粉丝圈子"
          title="找到你的那一个圈子"
          desc="按喜好聚合的小圈子，是深度交流的温暖据点。加入心仪的圈子，结识更多同好。"
        />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {circles.map((c) => (
            <article
              key={c.id}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-[8/5] w-full overflow-hidden">
                <img
                  src={c.cover}
                  alt={`${c.name} 粉丝圈子`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-group-2-fill text-[12px]"></i>
                  {c.member} 成员
                </span>
                <h3 className="absolute bottom-3 left-4 right-4 font-heading text-lg font-bold text-background-50">
                  {c.name}
                </h3>
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-flex items-center whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                  {c.tag}
                </span>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <button
                  type="button"
                  className="mt-4 inline-flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-4 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className="ri-add-line text-base"></i>
                  加入圈子
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}